import styled from "styled-components";
import { Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        background-color: rgb(221, 221, 221);
        border: 1px solid white !important;
    }

    & > thead > tr > th {
        cursor: default;
    }

    thead th:first-child {
        border-radius: 4px 0 0 0px;
    }

    thead th:last-child { 
        border-radius: 0 4px 0px 0;
    }

    & > tbody > tr:first-child > td,
    & > tbody > tr:first-child > th {
        border-top: none;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td:first-child {
        // text-align: left;
    }

    & > tbody > tr:nth-of-type(odd) > td.alternate-stripe {
        background-color: #ddeeff !important;
    }

    & > tbody > tr:nth-of-type(even) > td.alternate-stripe {
        background-color: #eef9ff !important;
    }

    // & thead > tr > th > div {
    //     text-align: left !important;
    //     transform: translate(30px, -1px) rotate(315deg);
    //     width: 35px;
    //     padding-left: 5px
    // }

    & tfoot > tr {
        text-align: center;
        background-color:rgb(131,175,221);
        font-weight: 600;
    }

    & tbody > tr:nth-child(odd) td:last-child {
        background-color: #FAFACC;
        font-weight: 600;
    }

    & tbody > tr:nth-child(even) td:last-child {
        background-color: #FFA;
        font-weight: 600;
    }
`;